import React, {CSSProperties, useMemo} from 'react'
import {UserStatus} from '@components/common/base/user-status'
import {cn} from '@containers/html-utils'
import {TwAvatar, TwShortName} from './containers'
import {AvatarBaseProps} from './types'
import {emptyAvatar, getOutlineSize, getStatusSize} from './utils'

export const AvatarBase = React.memo(
  React.forwardRef(
    (
      {
        user,
        hideStatus = false,
        hideOutline = false,
        outlineColor = 'grey-l100',
        outlineSize,
        size = 24,
        className,
        outlineClassName,
        onDragStart,
        hideHint = false,
        disabled = false,
        onClick
      }: AvatarBaseProps,
      ref
    ) => {
      const style = useMemo<CSSProperties>(() => {
        const invited = user.userEmail === user.userName
        const userAvatar = user.userImage ? `url("${user.userImage}")` : ''
        const emToPx = 0.4375
        const backgroundImage = invited ? emptyAvatar : userAvatar
        const backgroundColor = backgroundImage
          ? undefined
          : user.userBackgroundColor
        return {
          backgroundColor,
          backgroundImage,
          fontSize: `${size * emToPx}px`
        }
      }, [user, size])

      return (
        <TwAvatar
          ref={ref}
          $size={size}
          $disabled={disabled}
          $hideOutline={hideOutline}
          $outlineColor={outlineColor}
          $outlineSize={outlineSize}
          style={style}
          content={user.userInfo}
          onDragStart={onDragStart}
          draggable={!!onDragStart}
          className={cn(className, outlineClassName)}
          // empty `title` to prevent titles of any parent components showing
          // while `content` is displayed on hover
          title=""
          hideHint={hideHint}
          onClick={onClick}
        >
          {!user.userImage && <TwShortName>{user.userShortName}</TwShortName>}
          {!hideStatus && (
            <UserStatus
              userStatus={user.userStatus}
              userIsInDoNotDisturbMode={user.userIsInDoNotDisturbMode}
              size={getStatusSize(size)}
              hideOutline={hideOutline}
              outlineSize={getOutlineSize(size)}
              outlineColor={outlineColor}
              className={cn('absolute', 'bottom-0', 'left-0', outlineClassName)}
            />
          )}
        </TwAvatar>
      )
    }
  )
)
